const _c0 = ["icon"];
const _c1 = ["input"];
const _c2 = (a0, a1, a2) => ({
  checked: a0,
  class: a1,
  dataP: a2
});
function Checkbox_ng_container_3_ng_container_1_span_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "span", 8);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.cx("icon"));
    i0.ɵɵproperty("ngClass", ctx_r0.checkboxIcon)("pBind", ctx_r0.ptm("icon"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Checkbox_ng_container_3_ng_container_1__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 9);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵclassMap(ctx_r0.cx("icon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("icon"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Checkbox_ng_container_3_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Checkbox_ng_container_3_ng_container_1_span_1_Template, 1, 5, "span", 6)(2, Checkbox_ng_container_3_ng_container_1__svg_svg_2_Template, 1, 4, "svg", 7);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.checkboxIcon);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r0.checkboxIcon);
  }
}
function Checkbox_ng_container_3__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "svg", 10);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵclassMap(ctx_r0.cx("icon"));
    i0.ɵɵproperty("pBind", ctx_r0.ptm("icon"));
    i0.ɵɵattribute("data-p", ctx_r0.dataP);
  }
}
function Checkbox_ng_container_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, Checkbox_ng_container_3_ng_container_1_Template, 3, 2, "ng-container", 3)(2, Checkbox_ng_container_3__svg_svg_2_Template, 1, 4, "svg", 5);
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0.checked);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r0._indeterminate());
  }
}
function Checkbox_4_ng_template_0_Template(rf, ctx) {}
function Checkbox_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, Checkbox_4_ng_template_0_Template, 0, 0, "ng-template");
  }
}
export * from 'primeng/types/checkbox';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, InjectionToken, forwardRef, input, EventEmitter, signal, inject, computed, booleanAttribute, numberAttribute, ContentChildren, ContentChild, ViewChild, Output, Input, ViewEncapsulation, ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { contains, equals } from '@primeuix/utils';
import { SharedModule, PrimeTemplate } from 'primeng/api';
import { PARENT_INSTANCE } from 'primeng/basecomponent';
import { BaseEditableHolder } from 'primeng/baseeditableholder';
import * as i1 from 'primeng/bind';
import { Bind, BindModule } from 'primeng/bind';
import { CheckIcon } from 'primeng/icons/check';
import { MinusIcon } from 'primeng/icons/minus';
import { style as style$1 } from '@primeuix/styles/checkbox';
import { BaseStyle } from 'primeng/base';
const style = /*css*/`
    ${style$1}

    /* For PrimeNG */
    p-checkBox.ng-invalid.ng-dirty .p-checkbox-box,
    p-check-box.ng-invalid.ng-dirty .p-checkbox-box,
    p-checkbox.ng-invalid.ng-dirty .p-checkbox-box {
        border-color: dt('checkbox.invalid.border.color');
    }
`;
const classes = {
  root: ({
    instance
  }) => ['p-checkbox p-component', {
    'p-checkbox-checked p-highlight': instance.checked,
    'p-disabled': instance.$disabled(),
    'p-invalid': instance.invalid(),
    'p-variant-filled': instance.$variant() === 'filled',
    'p-checkbox-sm p-inputfield-sm': instance.size() === 'small',
    'p-checkbox-lg p-inputfield-lg': instance.size() === 'large'
  }],
  box: 'p-checkbox-box',
  input: 'p-checkbox-input',
  icon: 'p-checkbox-icon'
};
let CheckboxStyle = /*#__PURE__*/(() => {
  class CheckboxStyle extends BaseStyle {
    name = 'checkbox';
    style = style;
    classes = classes;
    static ɵfac = /* @__PURE__ */(() => {
      let ɵCheckboxStyle_BaseFactory;
      return function CheckboxStyle_Factory(__ngFactoryType__) {
        return (ɵCheckboxStyle_BaseFactory || (ɵCheckboxStyle_BaseFactory = i0.ɵɵgetInheritedFactory(CheckboxStyle)))(__ngFactoryType__ || CheckboxStyle);
      };
    })();
    static ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: CheckboxStyle,
      factory: CheckboxStyle.ɵfac
    });
  }
  return CheckboxStyle;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
/**
 *
 * Checkbox is an extension to standard checkbox element with theming.
 *
 * [Live Demo](https://www.primeng.org/checkbox/)
 *
 * @module checkboxstyle
 *
 */
var CheckboxClasses = /*#__PURE__*/function (CheckboxClasses) {
  /**
   * Class name of the root element
   */
  CheckboxClasses["root"] = "p-checkbox";
  /**
   * Class name of the box element
   */
  CheckboxClasses["box"] = "p-checkbox-box";
  /**
   * Class name of the input element
   */
  CheckboxClasses["input"] = "p-checkbox-input";
  /**
   * Class name of the icon element
   */
  CheckboxClasses["icon"] = "p-checkbox-icon";
  return CheckboxClasses;
}(CheckboxClasses || {});
const CHECKBOX_INSTANCE = /*#__PURE__*/new InjectionToken('CHECKBOX_INSTANCE');
const CHECKBOX_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => Checkbox),
  multi: true
};
/**
 * Checkbox is an extension to standard checkbox element with theming.
 * @group Components
 */
let Checkbox = /*#__PURE__*/(() => {
  class Checkbox extends BaseEditableHolder {
    componentName = 'Checkbox';
    hostName = '';
    /**
     * Value of the checkbox.
     * @group Props
     */
    value;
    /**
     * Allows to select a boolean value instead of multiple values.
     * @group Props
     */
    binary;
    /**
     * Establishes relationships between the component and label(s) where its value should be one or more element IDs.
     * @group Props
     */
    ariaLabelledBy;
    /**
     * Used to define a string that labels the input element.
     * @group Props
     */
    ariaLabel;
    /**
     * Index of the element in tabbing order.
     * @group Props
     */
    tabindex;
    /**
     * Identifier of the focus input to match a label defined for the component.
     * @group Props
     */
    inputId;
    /**
     * Inline style of the input element.
     * @group Props
     */
    inputStyle;
    /**
     * Style class of the component.
     * @deprecated since v20.0.0, use `class` instead.
     * @group Props
     */
    styleClass;
    /**
     * Style class of the input element.
     * @group Props
     */
    inputClass;
    /**
     * When present, it specifies input state as indeterminate.
     * @group Props
     */
    indeterminate = false;
    /**
     * Form control value.
     * @group Props
     */
    formControl;
    /**
     * Icon class of the checkbox icon.
     * @group Props
     */
    checkboxIcon;
    /**
     * When present, it specifies that the component cannot be edited.
     * @group Props
     */
    readonly;
    /**
     * When present, it specifies that the component should automatically get focus on load.
     * @group Props
     */
    autofocus;
    /**
     * Value in checked state.
     * @group Props
     */
    trueValue = true;
    /**
     * Value in unchecked state.
     * @group Props
     */
    falseValue = false;
    /**
     * Specifies the input variant of the component.
     * @defaultValue undefined
     * @group Props
     */
    variant = input(...(ngDevMode ? [undefined, {
      debugName: "variant"
    }] : []));
    /**
     * Specifies the size of the component.
     * @defaultValue undefined
     * @group Props
     */
    size = input(...(ngDevMode ? [undefined, {
      debugName: "size"
    }] : []));
    /**
     * Callback to invoke on value change.
     * @param {CheckboxChangeEvent} event - Custom value change event.
     * @group Emits
     */
    onChange = new EventEmitter();
    /**
     * Callback to invoke when the receives focus.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onFocus = new EventEmitter();
    /**
     * Callback to invoke when the loses focus.
     * @param {Event} event - Browser event.
     * @group Emits
     */
    onBlur = new EventEmitter();
    inputViewChild;
    get checked() {
      return this._indeterminate() ? false : this.binary ? this.modelValue() === this.trueValue : contains(this.value, this.modelValue());
    }
    _indeterminate = signal(undefined, ...(ngDevMode ? [{
      debugName: "_indeterminate"
    }] : []));
    /**
     * Custom checkbox icon template.
     * @group Templates
     */
    checkboxIconTemplate;
    templates;
    _checkboxIconTemplate;
    focused = false;
    _componentStyle = inject(CheckboxStyle);
    bindDirectiveInstance = inject(Bind, {
      self: true
    });
    $pcCheckbox = inject(CHECKBOX_INSTANCE, {
      optional: true,
      skipSelf: true
    }) ?? undefined;
    $variant = computed(() => this.variant() || this.config.inputStyle() || this.config.inputVariant(), ...(ngDevMode ? [{
      debugName: "$variant"
    }] : []));
    onAfterContentInit() {
      this.templates?.forEach(item => {
        switch (item.getType()) {
          case 'icon':
            this._checkboxIconTemplate = item.template;
            break;
          case 'checkboxicon':
            this._checkboxIconTemplate = item.template;
            break;
        }
      });
    }
    onChanges(changes) {
      if (changes.indeterminate) {
        this._indeterminate.set(changes.indeterminate.currentValue);
      }
    }
    onAfterViewChecked() {
      this.bindDirectiveInstance.setAttrs(this.ptms(['host', 'root']));
    }
    updateModel(event) {
      let newModelValue;
      /*
       * When `formControlName` or `formControl` is used - `writeValue` is not called after control changes.
       * Otherwise it is causing multiple references to the actual value: there is one array reference inside the component and another one in the control value.
       * `selfControl` is the source of truth of references, it is made to avoid reference loss.
       * */
      const selfControl = this.injector.get(NgControl, null, {
        optional: true,
        self: true
      });
      const currentModelValue = selfControl && !this.formControl ? selfControl.value : this.modelValue();
      if (!this.binary) {
        if (this.checked || this._indeterminate()) newModelValue = currentModelValue.filter(val => !equals(val, this.value));else newModelValue = currentModelValue ? [...currentModelValue, this.value] : [this.value];
        this.onModelChange(newModelValue);
        this.writeModelValue(newModelValue);
        if (this.formControl) {
          this.formControl.setValue(newModelValue);
        }
      } else {
        newModelValue = this._indeterminate() ? this.trueValue : this.checked ? this.falseValue : this.trueValue;
        this.writeModelValue(newModelValue);
        this.onModelChange(newModelValue);
      }
      if (this._indeterminate()) {
        this._indeterminate.set(false);
      }
      this.onChange.emit({
        checked: newModelValue,
        originalEvent: event
      });
    }
    handleChange(event) {
      if (!this.readonly) {
        this.updateModel(event);
      }
    }
    onInputFocus(event) {
      this.focused = true;
      this.onFocus.emit(event);
    }
    onInputBlur(event) {
      this.focused = false;
      this.onBlur.emit(event);
      this.onModelTouched();
    }
    focus() {
      this.inputViewChild?.nativeElement.focus();
    }
    /**
     * @override
     *
     * @see {@link BaseEditableHolder.writeControlValue}
     * Writes the value to the control.
     */
    writeControlValue(value, setModelValue) {
      setModelValue(value);
      this.cd.markForCheck();
    }
    get dataP() {
      return this.cn({
        invalid: this.invalid(),
        checked: this.checked,
        disabled: this.$disabled(),
        filled: this.$variant() === 'filled',
        [this.size()]: this.size()
      });
    }
    static ɵfac = /* @__PURE__ */(() => {
      let ɵCheckbox_BaseFactory;
      return function Checkbox_Factory(__ngFactoryType__) {
        return (ɵCheckbox_BaseFactory || (ɵCheckbox_BaseFactory = i0.ɵɵgetInheritedFactory(Checkbox)))(__ngFactoryType__ || Checkbox);
      };
    })();
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: Checkbox,
      selectors: [["p-checkbox"], ["p-checkBox"], ["p-check-box"]],
      contentQueries: function Checkbox_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, _c0, 4)(dirIndex, PrimeTemplate, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.checkboxIconTemplate = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
        }
      },
      viewQuery: function Checkbox_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c1, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.inputViewChild = _t.first);
        }
      },
      hostVars: 6,
      hostBindings: function Checkbox_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵattribute("data-p-highlight", ctx.checked)("data-p-checked", ctx.checked)("data-p-disabled", ctx.$disabled())("data-p", ctx.dataP);
          i0.ɵɵclassMap(ctx.cn(ctx.cx("root"), ctx.styleClass));
        }
      },
      inputs: {
        hostName: "hostName",
        value: "value",
        binary: [2, "binary", "binary", booleanAttribute],
        ariaLabelledBy: "ariaLabelledBy",
        ariaLabel: "ariaLabel",
        tabindex: [2, "tabindex", "tabindex", numberAttribute],
        inputId: "inputId",
        inputStyle: "inputStyle",
        styleClass: "styleClass",
        inputClass: "inputClass",
        indeterminate: [2, "indeterminate", "indeterminate", booleanAttribute],
        formControl: "formControl",
        checkboxIcon: "checkboxIcon",
        readonly: [2, "readonly", "readonly", booleanAttribute],
        autofocus: [2, "autofocus", "autofocus", booleanAttribute],
        trueValue: "trueValue",
        falseValue: "falseValue",
        variant: [1, "variant"],
        size: [1, "size"]
      },
      outputs: {
        onChange: "onChange",
        onFocus: "onFocus",
        onBlur: "onBlur"
      },
      features: [i0.ɵɵProvidersFeature([CHECKBOX_VALUE_ACCESSOR, CheckboxStyle, {
        provide: CHECKBOX_INSTANCE,
        useExisting: Checkbox
      }, {
        provide: PARENT_INSTANCE,
        useExisting: Checkbox
      }]), i0.ɵɵHostDirectivesFeature([i1.Bind]), i0.ɵɵInheritDefinitionFeature],
      decls: 5,
      vars: 26,
      consts: [["input", ""], ["type", "checkbox", 3, "focus", "blur", "change", "checked", "pBind"], [3, "pBind"], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["data-p-icon", "minus", 3, "class", "pBind", 4, "ngIf"], [3, "class", "ngClass", "pBind", 4, "ngIf"], ["data-p-icon", "check", 3, "class", "pBind", 4, "ngIf"], [3, "ngClass", "pBind"], ["data-p-icon", "check", 3, "pBind"], ["data-p-icon", "minus", 3, "pBind"]],
      template: function Checkbox_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "input", 1, 0);
          i0.ɵɵlistener("focus", function Checkbox_Template_input_focus_0_listener($event) {
            return ctx.onInputFocus($event);
          })("blur", function Checkbox_Template_input_blur_0_listener($event) {
            return ctx.onInputBlur($event);
          })("change", function Checkbox_Template_input_change_0_listener($event) {
            return ctx.handleChange($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(2, "div", 2);
          i0.ɵɵtemplate(3, Checkbox_ng_container_3_Template, 3, 2, "ng-container", 3)(4, Checkbox_4_Template, 1, 0, null, 4);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵstyleMap(ctx.inputStyle);
          i0.ɵɵclassMap(ctx.cn(ctx.cx("input"), ctx.inputClass));
          i0.ɵɵproperty("checked", ctx.checked)("pBind", ctx.ptm("input"));
          i0.ɵɵattribute("id", ctx.inputId)("value", ctx.value)("name", ctx.name())("tabindex", ctx.tabindex)("required", ctx.required() ? "" : undefined)("readonly", ctx.readonly ? "" : undefined)("disabled", ctx.$disabled() ? "" : undefined)("aria-labelledby", ctx.ariaLabelledBy)("aria-label", ctx.ariaLabel);
          i0.ɵɵadvance(2);
          i0.ɵɵclassMap(ctx.cx("box"));
          i0.ɵɵproperty("pBind", ctx.ptm("box"));
          i0.ɵɵattribute("data-p", ctx.dataP);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.checkboxIconTemplate && !ctx._checkboxIconTemplate);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngTemplateOutlet", ctx.checkboxIconTemplate || ctx._checkboxIconTemplate)("ngTemplateOutletContext", i0.ɵɵpureFunction3(22, _c2, ctx.checked, ctx.cx("icon"), ctx.dataP));
        }
      },
      dependencies: [CommonModule, i2.NgClass, i2.NgIf, i2.NgTemplateOutlet, SharedModule, CheckIcon, MinusIcon, BindModule, i1.Bind],
      encapsulation: 2,
      changeDetection: 0
    });
  }
  return Checkbox;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CheckboxModule = /*#__PURE__*/(() => {
  class CheckboxModule {
    static ɵfac = function CheckboxModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || CheckboxModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: CheckboxModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [Checkbox, SharedModule, SharedModule]
    });
  }
  return CheckboxModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CHECKBOX_VALUE_ACCESSOR, Checkbox, CheckboxClasses, CheckboxModule, CheckboxStyle };
